module.exports = __webpack_public_path__ + "media/images/add-96352f68f1941e91c57323992b9ca54a.png";